import { createScriptIn } from './ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { ClientUserState } from './ClientUserState.ts';
export class GoogleOneTapLoader {
    static init() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) {
            var _document_getElementById;
            (_document_getElementById = document.getElementById('g_id_onload')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute('data-auto_prompt', 'false');
            this.cancelPopup();
            this.delayedCancelPopup();
        } else {
            var _document_getElementById1;
            (_document_getElementById1 = document.getElementById('g_id_onload')) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.setAttribute('data-auto_prompt', 'true');
        }
        if (this.initialized) return;
        if (UIUtilsEjsVariables.isUserOnMobile) return;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.isLoggedIn) return;
        createScriptIn(document.body, 'https://accounts.google.com/gsi/client');
        this.initialized = true;
    }
    static cancelPopup() {
        var // @ts-expect-error window.google unknown
        _window_google_accounts_id, _window_google_accounts, _window_google;
        (_window_google = window.google) === null || _window_google === void 0 ? void 0 : (_window_google_accounts = _window_google.accounts) === null || _window_google_accounts === void 0 ? void 0 : (_window_google_accounts_id = _window_google_accounts.id) === null || _window_google_accounts_id === void 0 ? void 0 : _window_google_accounts_id.cancel();
    }
    static delayedCancelPopup() {
        if (!this.initialized) return;
        for(let timeout = 0; timeout < 2000; timeout += 500){
            setTimeout(()=>{
                this.cancelPopup();
            }, timeout);
        }
    }
}
GoogleOneTapLoader.initialized = false;
